class ProductCards 
{
    static selectVariant(btn)
    {   
        const productCardId = btn.dataset.forProductCard;
        const productCard = document.querySelector(`#${productCardId}`); 
        const addToBasketBtn = productCard.querySelector('.add-to-cart-btn');

        const variantId = btn.dataset.variantId;
        const price = btn.dataset.price;
        const priceRaw = parseInt(btn.dataset.priceRaw);
        const comparePrice = btn.dataset.comparePrice;
        const comparePriceRaw = parseInt(btn.dataset.comparePriceRaw);
        const stockStatus = btn.dataset.stockStatus; 

        //const allVariantBtnsOnThisCard = btn.parentElement.querySelectorAll('.variant-btn');
        const allVariantBtnsOnThisCard = productCard.querySelectorAll('.variant-btn');
        // reset / remove active from all variant btns on this card
        ProductCards.resetVariantBtns(allVariantBtnsOnThisCard); 
        // apply active class to this btn
        btn.classList.add('active');

        // update price on card
        const productCardBottom = productCard.querySelector('.product-card-bottom');
        const priceEl = productCardBottom.querySelector('.price');
        const nowPriceEl = priceEl.querySelector('.now-price');
        const comparePriceEl = priceEl.querySelector('.compare-price');

        nowPriceEl.innerHTML = price;
        
        if (comparePriceRaw == NaN || (comparePriceRaw != NaN && comparePriceRaw < 1))
        {
            comparePriceEl.innerHTML = '';
        }
        else{
            comparePriceEl.innerHTML = comparePrice;
        }

        // set out of stock button if this variant has no stock
        if (stockStatus == 'out_of_stock')
        {
            if (!addToBasketBtn.classList.contains('out_of_stock'))
            {
                addToBasketBtn.classList.add('out_of_stock');
                addToBasketBtn.innerHTML = 'Out of Stock';
            }

            addToBasketBtn.disabled = true;
        }
        else
        {
            if (addToBasketBtn.classList.contains('out_of_stock'))
            {
                addToBasketBtn.classList.remove('out_of_stock');
                addToBasketBtn.innerHTML = 'Add to Basket';
            }

            addToBasketBtn.disabled = false;

        }

        // set the selected variant Id on the card
        productCard.dataset.selectedVariantId = variantId;
        // set the selected variant Id on the add to basket btn
        addToBasketBtn.dataset.selectedVariantId = variantId;

    }

    static resetVariantBtns(btns)
    {
        btns.forEach(function(btn){
            btn.classList.remove('active');
        });
    }

    static addToCart(btn) {

        const variantId = btn.dataset.selectedVariantId;
        const optionalQuantityInput = document.getElementById("quantity");
        const quantity = optionalQuantityInput ? parseInt(optionalQuantityInput.value) || 1 : 1;

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
            },
            body: JSON.stringify({
            id: variantId,
            quantity: quantity
            })
        })
        .then(response => response.json())
        .then(data => {
            if (typeof data.id == 'undefined' || data.id == null || parseInt(data.id) < 1)
            {
                alert("Unable to add that product to cart!");
            }
            // successfully added at this point
            if (typeof cartDrawer != 'undefined' && typeof cartDrawer.open == 'function') 
            {
                // cart drawer object is available
                cartDrawer.open();
                return; 
            }
            else
            {
                // cart drawer object not available, redirect to cart instead
                location.href = '/cart';
                return;
            }
        })
        .catch(error => {
            console.error('Error adding to cart:', error);
        });
    }
}